// src/app/modules/Members/MembersMainPage.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import { Operations } from "./Management";
import { OperationsMock } from "./OperationsMock";
// import { MemberDetails } from "./MemberDetails";
import { shallowEqual, useSelector } from "react-redux";

export function ManagementMainPage() {
  
  const { org } = useSelector(
    (state) => ({
      org: state.auth.organization,
    }),
    shallowEqual
  );

  return (
    <Routes>
      {/* Main members list */}
      {/* <Route path="/" element={<OperationsMock />} /> */}
      <Route path="/" element={<Operations />} />

      {/* Member details page */}
      {/* <Route 
        path="/view/:id" 
        element={<MemberDetails organizationId={org?.organization_id} />} 
      /> */}
    </Routes>
  );
}